import React from 'react';
import { Input } from 'bootstrap';

export default {
  getRadioWithLabelNode(checked, label) {
    return (
      <div className="column-menu-input">
        <Input type="radio" checked={checked} />
        {label}
      </div>
    );
  },
};
